import { SelectedFilter } from "../../../components/Filters/types";


export const surveysQueryKeys = {
  feelings: {
    all: () => ['feelings'],
    byFilters: (params: SelectedFilter[]) => {
      const serializedParams = JSON.stringify(params);
      return ['feelings', serializedParams];
    },
  },
  filters: {
    all: ['filters'] as const,
  },
};